module.exports = __webpack_public_path__ + "img/japan-blood-diseases-female.2ba7ffbf.png";